export interface AppCommentKeyParams {
  applicationID: string;
}

export const appCommentKeys = {
  root: (params: AppCommentKeyParams) =>
    ['app-comment', params.applicationID] as const,
  update: (params: AppCommentKeyParams) =>
    [...appCommentKeys.root(params), 'update'] as const,
};

export function parseAppCommentKey<T extends keyof typeof appCommentKeys>(
  queryKey: ReturnType<(typeof appCommentKeys)[T]>
) {
  const [, applicationID] = queryKey;
  return { applicationID };
}
